import React from "react";
import {
    FormGroup,
    Input,
    Label,
} from "reactstrap";
import FormUploadFiles from "./FormUploadFiles";


class DataTableForm extends React.Component {
    constructor(props) {
        super(props);
    }

    handleType(data) {

        return (
            <FormGroup>
                <div className="row mb-3">
                    <Label for={data.name}
                           className="col-sm-2 col-4 col-form-label">{data.name}</Label>
                    <div className="col-sm-10 col-8">

                        {(data.type === 'int') &&
                        <Input type="number"
                               name={data.name}
                               id={data.id}
                               placeholder={data.name}
                               maxLength={data.max_length && data.max_length}
                               onChange={this.props.onChange}
                               defaultValue={this.props.itemValue}
                        />
                        }

                        {(data.type === 'varchar') &&
                        <Input type="text"
                               name={data.name}
                               id={data.name}
                               placeholder={data.name}
                               maxLength={data.max_length && data.max_length}
                               required={(!data.nullable)}
                               onChange={this.props.onChange}
                               defaultValue={this.props.itemValue}
                        />
                        }

                        {(data.type === 'tinytext') &&
                        <Input type="text"
                               name={data.name}
                               id={data.name}
                               placeholder={data.name}
                               required={(!data.nullable)}
                               onChange={this.props.onChange}
                               defaultValue={this.props.itemValue}
                        />
                        }

                        {(data.type === 'password') &&
                        <Input type="password"
                               name={data.name}
                               id={data.id}
                               placeholder={data.name}
                               maxLength={data.max_length && data.max_length}
                               required={(!data.nullable)}
                               onChange={this.props.onChange}
                               defaultValue={this.props.itemValue}
                        />
                        }

                        {(data.type === 'datetime') &&
                        <Input type="datetime"
                               name={data.name}
                               id={data.id}
                               placeholder={data.name}
                               maxLength={data.max_length && data.max_length}
                               required={(!data.nullable)}
                               onChange={this.props.onChange}
                               defaultValue={this.props.itemValue}
                        />
                        }

                        {(data.type === 'image') &&
                        <FormUploadFiles
                            {...this.props}
                            name={data.name}
                            upload={this.props.upload}
                            defaultValue={this.props.itemValue} />
                        }

                    </div>
                </div>
            </FormGroup>
        )
    }

    render() {
        const result = this.handleType(this.props.fields);
        return <div>{result}</div>;

    }
}

export default DataTableForm;